import { render, staticRenderFns } from "./APIPagination.vue?vue&type=template&id=ae126ffe&"
import script from "./APIPagination.vue?vue&type=script&lang=ts&"
export * from "./APIPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports